import React, { useEffect, useState, useContext, useRef } from 'react';
import ContentHeader from './ContentHeader';
import Header from './Header';
import Footer from './Footer';
import helpers from '../../services/helpers';
import "primereact/resources/themes/lara-light-blue/theme.css";
//import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import FormContext from '../../services/formContext';

function Layout ({
        page_title='', 
        menu="", 
        breadcrumbs=true, 
        children, 
        parent_link='', 
        parent_text='',
        containerClass="container-fluid"
    }){
    
    return (
        <div>
            {/* {
                helpers.isAuthenticated() ? <Header menu={menu} /> : ''
            } */}
            <Header menu={menu} />

            <div className="content-wrapper pb-3">
                <ContentHeader title={page_title} breadcrumbs={breadcrumbs}  parent_link={parent_link} parent_text={parent_text} containerClass={containerClass} />
                
                <section className="content">
                    {children}
                </section>

            </div>

            <Footer />
        </div>
    )
}
 
export default Layout;